import React, { useMemo } from 'react'; 
import { useLocation, Link } from 'react-router-dom'
import { useSelector } from "react-redux"; 
import { Badge } from 'antd';

function DashboardSideBar(props) { 
    

    const location = useLocation();  
    const {messageData} = useSelector(state => state);  


    const messageCountShow = useMemo(
        () => {
            if(messageData.length > 0){
                let filterMessage = messageData.filter( (item) => { return (item.readAt === undefined && item.send_by === "patient") })  
               return filterMessage.length
            }else{
                return 0;
            }
            
      });

    return (
        <aside className="main-sidebar"> 
            <div className="slimScrollDiv">
                
            <section className="sidebar">   
            <ul className="sidebar-menu tree" data-widget="tree">
        
                <li className={ (location.pathname == '/dashboard')? "active" : ""}>
                     <Link to="/dashboard">
                        <i className="profile"></i> <span>My Profile</span> 
                    </Link> 
                </li>  
        
                <li className={ (location.pathname == '/my-assignment')? "active" : ""}>
                    <Link to="/my-assignment">
                        <i className="medical_profile"></i> <span>My Assignements</span> 
                    </Link>  
                </li>  
                <li className={ (location.pathname == '/video-calls')? "active" : ""}>
                    <Link to="/video-calls">
                         <i className="video-calls"></i> <span>Video Calls</span>
                    </Link> 
                </li>   
                <li>
                    <Link to="/all-messages">
                         <i className="message"></i> <span>Messages <Badge style={{backgroundColor: '#f44336', borderColor: '#f44336' }} count={messageCountShow} offset={[20, -2]}> </Badge></span>
                    </Link> 
                </li>  
                {/* <li>
                    <Link to="/create-meeting">
                         <i className="video-calls"></i> <span>Meeting</span>
                    </Link> 
                </li>   */}
               
            </ul>
            </section> 
            </div>
            
        </aside>
    );
  }
  
  export default DashboardSideBar;

